/**
 * The StoryFrameworkPlayerFactory provides the functionality to instantiate a StoryFrameworkPlayer and
 * a StoryFrameworkPlayerMemento. The StoryPlayerFactory is the only way to instantiate the 
 * implementations of the interfaces. 
 **/
import StoryFrameworkPlayer from "./StoryFrameworkPlayer";
import StoryFrameworkPlayerMemento from "./StoryFrameworkPlayerMemento";

const StoryFrameworkPlayerFactory = {};
export default StoryFrameworkPlayerFactory;

/**
 * Create a new instance of an StoryFrameworkPlayer implementation
 * @param {Story} story The IStory to use with the IStoryPlayer
 * @param {IClock} clock The IClock to use in the I
 * @param {function} solver The function that the IStoryPlayer can call to resolve LogicalVarialbes
 * @return {StoryFrameworkPlayer} A StoryFrameworkPlayer instance
 **/
StoryFrameworkPlayerFactory.createStoryFrameworkPlayer = function(story, clock, solver) {
    return new StoryFrameworkPlayer(story, clock, solver);
};
/**
 * Create a new instance of an IStoryPlayerMemento implementation
 * @return {StoryFrameworkPlayerMemento}An StoryFrameworkPlayerMemento instance
 **/
StoryFrameworkPlayerFactory.createStoryFrameworkPlayerMemento = function() {
    return new StoryFrameworkPlayerMemento();
};